/* Variantes: cada una envuelve la utility class del canon tipográfico (typography.css). */
.displayL {
  composes: text-display-l from global;
}
.displayKpi {
  composes: text-display-kpi-value from global;
}
.h1 {
  composes: text-heading-h1 from global;
}
.h2 {
  composes: text-heading-h2 from global;
}
.h3 {
  composes: text-heading-h3 from global;
}
.body1 {
  composes: text-body-1 from global;
}
.body2 {
  composes: text-body-2 from global;
}
.body3 {
  composes: text-body-3 from global;
}
.caption {
  composes: text-body-caption from global;
}
.overline {
  composes: text-label-overline from global;
}
.toggle {
  composes: text-label-toggle from global;
}
.field {
  composes: text-label-field from global;
}
.button {
  composes: text-label-button from global;
}
.monoCode {
  composes: text-mono-code from global;
}

/* Color: fill override (4 tokens sancionados por Figma). */
.colorHi {
  color: var(--ds-color-text-hi);
}
.colorDefault {
  color: var(--ds-color-text-default);
}
.colorMute {
  color: var(--ds-color-text-mute);
}
.colorDisabled {
  color: var(--ds-color-text-disabled);
}
.colorOnPrimary {
  color: var(--ds-color-text-on-primary);
}
